module.exports = __webpack_public_path__ + "img/x-close.189bbb91.svg";